import React from "react";
import PropTypes from "prop-types";
import cs from "classnames";

import { renderContentfulComponent } from "@lululemon/cosy-contentful-renderer";
import { baseRenderContentType } from "@lululemon/ui-library";
import { ErrorBoundary } from "@lululemon/mwa-logger";

import WhyYouLoveThisAccordion from "./why-you-love-this-accordion";
import { productEdHandleError } from "../../utils/product-education-logger";

import styles from "./why-you-love-this.module.scss";

function WhyYouLoveThis({
  accordionItems,
  description,
  doubleLinedText,
  heading,
  intro,
  materialAndCare,
  media,
  deviceType,
  videoRef,
  handleAccordionItemClick,
  handleStoryBlocksMobileNavigation
}) {
  const hasValidMedia =
    (media?.fields && Object.keys(media?.fields)?.length > 0) || false;

  return (
    <ErrorBoundary
      onError={(error) =>
        productEdHandleError(error, "WhyYouLoveThis", "WhyYouLoveThis")
      }
    >
      <section
        className={cs(
          "wrapper container-fluid product-education-container",
          "OneLinkNoTx"
        )}
      >
        <div className={cs("lll-grid", styles.mediaHeader)}>
          {!!hasValidMedia && (
            <div className={styles.mediaWrapper}>
              {renderContentfulComponent({
                contentfulComponent: {
                  ...media,
                  fields: {
                    ...media?.fields,
                    portraitVideoUrl: null,
                    portraitVideoPreviewImageUrl: null
                  }
                },
                options: {
                  renderContentType: baseRenderContentType,
                  transformElement: ({ element, contentType }) => {
                    const extraProps =
                      contentType === "video"
                        ? {
                            refs: {
                              video: videoRef
                            }
                          }
                        : {};
                    return React.cloneElement(element, extraProps);
                  }
                }
              })}
            </div>
          )}
          <div className={styles.headingWrapper}>
            {intro && <h2 className={styles.intro}>{intro}</h2>}
            {heading && (
              <p className={cs("lll-text-medium", styles.heading)}>{heading}</p>
            )}
            {description && (
              <p className={cs(styles.description)}>{description}</p>
            )}
          </div>
        </div>
        {accordionItems && (
          <WhyYouLoveThisAccordion
            accordionItems={accordionItems}
            materialAndCare={materialAndCare}
            doubleLinedText={doubleLinedText}
            deviceType={deviceType}
            handleAccordionItemClick={handleAccordionItemClick}
            handleStoryBlocksMobileNavigation={
              handleStoryBlocksMobileNavigation
            }
          />
        )}
      </section>
    </ErrorBoundary>
  );
}

WhyYouLoveThis.defaultProps = {
  accordionItems: [],
  description: "",
  doubleLinedText: "",
  heading: "",
  intro: "",
  materialAndCare: {},
  media: {}
};

WhyYouLoveThis.propTypes = {
  accordionItems: PropTypes.array,
  description: PropTypes.string,
  doubleLinedText: PropTypes.string,
  heading: PropTypes.string,
  intro: PropTypes.string,
  materialAndCare: PropTypes.shape({
    sections: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  media: PropTypes.shape({}),
  deviceType: PropTypes.shape({
    isMobile: PropTypes.bool,
    isTablet: PropTypes.bool,
    isDesktop: PropTypes.bool
  }).isRequired,
  videoRef: PropTypes.object,
  handleAccordionItemClick: PropTypes.func,
  handleStoryBlocksMobileNavigation: PropTypes.func
};

export default WhyYouLoveThis;
